import { registerInstrumentations } from '@opentelemetry/instrumentation';
import { FetchInstrumentation } from '@opentelemetry/instrumentation-fetch';
import { XMLHttpRequestInstrumentation } from '@opentelemetry/instrumentation-xml-http-request';
import { resourceFromAttributes } from '@opentelemetry/resources';
import { BatchSpanProcessor } from '@opentelemetry/sdk-trace-base';
import { WebTracerProvider } from '@opentelemetry/sdk-trace-web';
import { W3CTraceContextPropagator } from '@opentelemetry/core';
import { BrowserSpanExporter } from './internal/BrowserSpanExporter.js';
import { installBrowserTransports, setBrowserTelemetryEnabled } from './internal/transports.js';
export { startBrowserConnection } from './internal/transports.js';
let initialized = false;
export function initWebTracing(config) {
    if (initialized ||
        !config.enabled ||
        !config.otlpEndpoint ||
        !config.bffOrigin ||
        typeof window === 'undefined')
        return;
    const endpoint = new URL(config.otlpEndpoint, window.location.href);
    const bff = new URL(config.bffOrigin, window.location.href);
    if (endpoint.origin !== bff.origin || !['http:', 'https:'].includes(bff.protocol))
        return;
    const send = globalThis.fetch.bind(globalThis);
    const provider = new WebTracerProvider({
        resource: resourceFromAttributes({
            'service.name': config.serviceName,
            'deployment.environment.name': config.environment ?? 'local',
        }),
        spanProcessors: [
            new BatchSpanProcessor(new BrowserSpanExporter(endpoint.href, send), {
                maxQueueSize: 256,
                maxExportBatchSize: 32,
                scheduledDelayMillis: 1000,
                exportTimeoutMillis: 3500,
            }),
        ],
    });
    provider.register({ propagator: new W3CTraceContextPropagator() });
    const escaped = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const clientErrorEndpoint = new URL('client-error', endpoint);
    const instrumentation = {
        propagateTraceHeaderCorsUrls: [new RegExp(`^${escaped(bff.origin)}(?:/|$)`)],
        ignoreUrls: [endpoint, clientErrorEndpoint].map((url) => new RegExp(`^${escaped(url.href)}(?:[?#]|$)`)),
    };
    registerInstrumentations({
        instrumentations: [
            new FetchInstrumentation(instrumentation),
            new XMLHttpRequestInstrumentation(instrumentation),
        ],
    });
    setBrowserTelemetryEnabled(true);
    installBrowserTransports(endpoint.href);
    window.addEventListener('pagehide', () => {
        void provider.forceFlush().catch(() => undefined);
    });
    initialized = true;
}
//# sourceMappingURL=index.js.map